import React, { useState } from "react";
import { API } from "../../actions/userAction";
import { Button, TextField } from "@mui/material";
import { useAlert } from "react-alert";
import { URL } from "../../constants/userConstants";

export default function ManualDeposit() {
  const alert = useAlert();
  const [userId, setUserId] = useState("");
  const [amount, setAmount] = useState("");

  const handleDeposit = async () => {
    try {
await API.post(
  "/api/admin/manual-deposit",
  {
    userId,
    amount,
  });

      alert.success("Deposit Added Successfully");
      setUserId("");
      setAmount("");
    } catch (err) {
      alert.error("Deposit Failed");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h3>Manual Deposit</h3>

      <TextField
        label="User ID"
        fullWidth
        margin="normal"
        value={userId}
        onChange={(e) => setUserId(e.target.value)}
      />

      <TextField
        label="Amount"
        type="number"
        fullWidth
        margin="normal"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
      />

      <Button
        variant="contained"
        color="success"
        onClick={handleDeposit}
      >
        Add Deposit
      </Button>
    </div>
  );
}
